export const EmptyAxis = ({ play = false }) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    aria-hidden="true"
    focusable="false"
    data-testid="empty-axis"
    className={`text-ax-muted${play ? " axis-draw" : ""}`}
  >
    <path className="axis-line" d="M14 4V34" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" />
    <path className="axis-line" d="M44 38H18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" />
    <path d="M14 32L20 38L14 44L8 38L14 32Z" fill="#0D9488" />
  </svg>
);
